<script setup>
/**
 * FormFieldsets
 * Structural component that loops through all available legends in the form's state.
 * It passes positional context to children to handle first/last fieldset logic.
 */
import { computed, getCurrentInstance } from 'vue';
import FormFieldset from './FormFieldset';

const props = defineProps({
    formId: {
        type: String,
        required: true
    },
    showLegends: Boolean,
    hideHelpText: Boolean
});

const { proxy } = getCurrentInstance();
const store = proxy.$store;

// --- Computed ---

const legends = computed(() => store.state[props.formId]?.legends || []);
</script>

<template>
    <div>
        <FormFieldset
            v-for="(legend, index) in legends"
            :key="legend"
            :form-id="formId"
            :is-first="index === 0"
            :is-last="index === legends.length - 1"
            :legend="legend"
            :show-legends="showLegends"
            :hide-help-text="hideHelpText"
        />
    </div>
</template>